// Mock data for Karina Negrín portfolio (frontend-only phase)

export const profile = {
  name: 'Karina Negrín',
  role: 'Psicóloga · Doula · Puericultora',
  shortBio:
    'Acompaño a mujeres y familias en procesos de salud mental, crianza, maternidad y lactancia, desde la escucha, el respeto y sin juicios.',
  longBio:
    'Soy Karina Negrín, licenciada en Psicología, puericultora, doula y diplomada en Psicología Perinatal. Hace más de 10 años acompaño a mujeres y familias en procesos de crianza, salud mental y maternidad. Trabajo desde un enfoque sistémico familiar, con perspectiva feminista, teoría del apego y crianza respetuosa. Escucho, acompaño y sostengo sin juicios. Me importa que cada mujer se sienta segura, validada y con herramientas para atravesar lo que está viviendo.',
  whatsapp: 'https://wa.me/59898884967',
  whatsappLabel: '+598 98 884 967',
  email: 'psic.karinanegrin@gmail.com',
  instagram: 'https://www.instagram.com/karinanegrinpsico',
  facebook: 'https://www.facebook.com/karinanegrinpueri',
  address: 'Ituzaingó 547, Rosario, Colonia, Uruguay.',
  hero: 'https://customer-assets.emergentagent.com/job_psych-portfolio-7/artifacts/lj1n6kku_DSC_0658.jpg',
  portrait: 'https://customer-assets.emergentagent.com/job_psych-portfolio-7/artifacts/lj1n6kku_DSC_0658.jpg',
  secondary: 'https://customer-assets.emergentagent.com/job_psych-portfolio-7/artifacts/z6xlclcn_DSC_0436.jpg',
  about: 'https://customer-assets.emergentagent.com/job_psych-portfolio-7/artifacts/5gyun3u4_DSC_0614.jpg',
};

export const services = [
  {
    id: 'psicologia',
    title: 'Psicología clínica',
    subtitle: 'Mujeres y niñ@s',
    icon: 'Sprout',
    image: 'https://customer-assets.emergentagent.com/job_psych-portfolio-7/artifacts/6znbn7zb_DSC_0665.jpg',
    description:
      'Procesos de psicodiagnóstico y psicoterapia. Un espacio para transitar momentos de cambio, preguntas, enredos o malestares que cuesta poner en palabras.',
    bullets: [
      'Mujeres en distintas etapas de la vida',
      'Cuerpo, vínculos, mandatos, deseo',
      'Duelos y decisiones difíciles',
      'Niñ@s: emociones, escuela, vínculos',
    ],
  },
  {
    id: 'perinatal',
    title: 'Psicología perinatal',
    subtitle: 'Embarazo, parto y posparto',
    icon: 'Flower2',
    image: 'https://images.unsplash.com/photo-1493894473891-10fc1e5dbd22?crop=entropy&cs=srgb&fm=jpg&w=1100&q=85',
    description:
      'Acompañamiento durante la búsqueda, el embarazo, el parto y el posparto. Sostén emocional para los tránsitos profundos de la maternidad.',
    bullets: [
      'Búsqueda y deseo de maternar',
      'Duelo gestacional y perinatal',
      'Depresión y ansiedad posparto',
      'Identidad y matrescencia',
    ],
  },
  {
    id: 'lactancia',
    title: 'Asesoría en lactancia',
    subtitle: 'Acompañamiento respetuoso',
    icon: 'HeartHandshake',
    image: 'https://customer-assets.emergentagent.com/job_psych-portfolio-7/artifacts/b3ai1umv_DSC_0541.jpg',
    description:
      'La lactancia no es igual para todas. Acompaño cada proceso desde la escucha, con información clara y sin juicios — incluyendo destetes y decisiones de no amamantar.',
    bullets: [
      'Inicio y primeros días',
      'Dificultades y dudas frecuentes',
      'Destete respetuoso',
      'Acompañamiento emocional',
    ],
  },
  {
    id: 'familiar',
    title: 'Terapia familiar',
    subtitle: 'Vínculos y crianza',
    icon: 'Users',
    image: 'https://images.unsplash.com/photo-1565340419825-cd1ac212cbce?crop=entropy&cs=srgb&fm=jpg&w=1100&q=85',
    description:
      'Trabajo con familias desde un enfoque sistémico, con perspectiva de género y teoría del apego. La crianza respetuosa como punto de partida.',
    bullets: [
      'Vínculos parento-filiales',
      'Conflictos de crianza',
      'Co-parentalidad',
      'Escuela y entorno',
    ],
  },
];

export const approach = [
  {
    title: 'Enfoque sistémico',
    body: 'Cada persona se entiende dentro de su contexto: historia, familia, entorno social y escolar.',
  },
  {
    title: 'Perspectiva de género',
    body: 'Una mirada que reconoce mandatos, desigualdades y la diversidad de las experiencias femeninas.',
  },
  {
    title: 'Teoría del apego',
    body: 'Los vínculos tempranos como base. Acompañar la crianza es también cuidar el desarrollo emocional.',
  },
  {
    title: 'Crianza respetuosa',
    body: 'Espacios donde se puedan expresar las emociones y repensar los vínculos sin juicios.',
  },
];

export const testimonials = [
  {
    name: 'Karina R.',
    role: 'Mamá primeriza',
    text: 'No tenía éxito en la lactancia, mi gorda no quería prenderse a la teta durante los primeros días. Consulté con Karina, coordinamos un encuentro por Zoom y realmente fue muy útil. Me enseñó técnicas y sentí un apoyo desde lo psicológico. Es una genia, me ayudó un montón.',
  },
  {
    name: 'Patricia T.',
    role: 'Mamá de paciente',
    text: 'Pienso en el trabajo de acompañamiento psicológico de Karina con mi hijo y aplaudo la dedicación y atención real. Le guía en su formación emocional brindándole herramientas concretas. Los espacios de devolución me brindan herramientas nuevas como mamá y persona.',
  },
  {
    name: 'Lucía M.',
    role: 'Embarazo de 32 semanas',
    text: 'Llegué con muchísimo miedo al parto y me fui sintiendo sostenida sesión a sesión. Karina escucha sin juzgar y eso, en este momento, es todo. Volví a confiar en mi cuerpo y en mí.',
  },
  {
    name: 'Sofía A.',
    role: 'Posparto',
    text: 'Después de mi segunda hija sentía que me estaba perdiendo. El espacio con Karina fue un refugio donde pude armar las piezas y volver a encontrarme.',
  },
];

export const articles = [
  {
    id: 'conservacion-leche',
    title: 'Conservación de leche materna',
    excerpt: 'Guía práctica basada en estándares internacionales: cómo, cuándo y dónde almacenarla con seguridad.',
    date: '20 de febrero, 2026',
    readTime: '6 min',
    category: 'Lactancia',
    image: 'https://images.unsplash.com/photo-1622428051717-dcd8412959de?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    sections: [
      {
        type: 'p',
        text: 'Cuando extraés leche materna, la forma en que la guardás hace la diferencia: conserva mejor sus defensas, se mantiene segura, y además te simplifica un poco la vida.',
      },
      {
        type: 'p',
        text: 'Acá tenés una guía clara, actualizada y fácil de aplicar en tu casa (para bebés sanos, nacidos a término; en prematuros o internación las indicaciones pueden ser más estrictas).',
      },
      { type: 'h', text: 'Tiempos de conservación recomendados' },
      {
        type: 'p',
        text: 'A temperatura ambiente (hasta 25 °C aprox.): hasta 4 horas (lo ideal es usarla o refrigerarla dentro de ese margen). Si el ambiente está más caluroso, mejor refrigerar cuanto antes.',
      },
      {
        type: 'p',
        text: 'Heladera (≤ 4 °C): hasta 4 días. Si sabés que no la vas a usar dentro de ese plazo, conviene freezar antes.',
      },
      {
        type: 'p',
        text: 'Freezer (con puerta propia, –18 °C aprox.): 6 meses es lo mejor en calidad; hasta 12 meses sigue siendo segura, aunque puede perder más calidad.',
      },
      {
        type: 'p',
        text: 'En bolsita conservadora con hielo o refrigerantes (viajes o traslados): hasta 24 horas.',
      },
      { type: 'h', text: 'Dónde guardarla en la heladera (este detalle importa)' },
      {
        type: 'list',
        items: [
          'Guardala en el fondo, en la parte más fría y estable (no en la puerta, donde hay más cambios de temperatura).',
          'Si podés, evitá ubicarla pegada a la pared del fondo si tu heladera “congela” cosas: que esté fría, sí, pero no cristalizada.',
        ],
      },
      { type: 'h', text: 'Recipientes y porcionado (para no desperdiciar)' },
      {
        type: 'list',
        items: [
          'Usá frascos de vidrio o recipientes plásticos aptos para alimentos (idealmente pensados para leche materna) o bolsas específicas para freezer.',
          'Porciones chicas (60–120 ml aprox., o lo que tu bebé suele tomar) para descongelar solo lo necesario.',
          'Al freezar, dejá espacio arriba: la leche se expande.',
          'Rotulá con fecha (y si va a guardería, también nombre).',
          'Regla simple: “primero entra, primero sale” (usar siempre la más antigua primero).',
        ],
      },
      { type: 'h', text: 'Cómo descongelar y calentar, sin arruinar la leche' },
      {
        type: 'p',
        text: 'La mejor forma (la más amable con la leche): pasarla del freezer a la heladera y dejar que se descongele lento (por ejemplo, de noche para usar al día siguiente).',
      },
      {
        type: 'p',
        text: 'Si la necesitás “ya”: poner el recipiente en agua tibia (baño maría suave) o bajo chorro de agua tibia.',
      },
      {
        type: 'p',
        text: 'Lo que NO recomendamos: microondas (calienta de forma desigual, riesgo de “puntos calientes” y puede afectar componentes valiosos), hervirla o calentarla a fuego directo.',
      },
      {
        type: 'p',
        text: 'Cuando se descongela, puede separarse (una parte más cremosa arriba). Es normal: mezclala con movimientos suaves, tipo “remolino” (no hace falta agitar fuerte).',
      },
      { type: 'h', text: 'Una vez descongelada: ¿cuánto dura?' },
      {
        type: 'list',
        items: [
          'Descongelada en heladera: usar dentro de 24 horas.',
          'Ya calentada o a temperatura ambiente para ofrecer: idealmente usar en 1–2 horas.',
          'No volver a freezar leche que ya se descongeló completamente.',
          'Sobras de la mema: si el bebé ya tomó de esa mamadera, por seguridad se suele recomendar descartar lo que queda (por contaminación con saliva).',
        ],
      },
      { type: 'h', text: 'Higiene básica (sin obsesión, pero con sentido)' },
      {
        type: 'list',
        items: [
          'Lavado de manos antes de extraer o manipular leche.',
          'Recipientes limpios y secos; y si usás extractor, seguir la rutina de limpieza recomendada por el fabricante.',
        ],
      },
      { type: 'h', text: 'Señales que suelen preocupar… y no siempre son un problema' },
      {
        type: 'p',
        text: 'Olor o jabonosidad: algunas personas tienen leche con más lipasa y al guardar puede oler distinto. Si el bebé la toma bien, suele ser perfectamente utilizable. Si la rechaza, se pueden evaluar estrategias, pero primero vemos qué pasa en tu caso.',
      },
      {
        type: 'p',
        text: 'Conservar leche materna no es solo técnica: es una forma de cuidar ese tiempo, ese cuerpo y ese vínculo que hicieron posible esa leche. No es hacerlo “perfecto”, pero sí lo suficientemente seguro y posible para cada familia, en el contexto real en el que vive.',
      },
      {
        type: 'p',
        text: 'Si algo de todo esto te genera dudas, incomodidad o te parece difícil de llevar a la práctica, es válido. Cada experiencia de lactancia es única, y no todas las casas, trabajos o rutinas permiten lo mismo. A veces, un pequeño ajuste alcanza para que todo sea más llevadero.',
      },
      {
        type: 'p',
        text: 'Si necesitás acompañamiento personalizado —para organizar extracciones, armar un banco de leche en casa o encontrar estrategias que se adapten a tu día a día— estoy para acompañarte.',
      },
      { type: 'sign', text: 'Un abrazo,\nKarina' },
    ],
  },
  {
    id: 'fiestas-amplifican',
    title: 'Las fiestas amplifican lo que ya veníamos sosteniendo',
    excerpt: 'Cómo sobrevivir al huracán de azúcar y sociales siendo madres.',
    date: '7 de diciembre, 2025',
    readTime: '5 min',
    category: 'Maternidad',
    image: 'https://images.unsplash.com/photo-1633494688418-f675425b9efc?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    sections: [
      {
        type: 'p',
        text: 'Las fiestas tienen esa forma particular de iluminar lo que veníamos cargando… para bien y para mal.',
      },
      {
        type: 'p',
        text: 'A veces nos cuentan que “la Navidad es para disfrutar”, que “hay que estar agradecidas”, que “es un momento para estar bien en familia”. Y sí, puede ser. Pero también es un tiempo donde se mezclan cansancio acumulado, expectativas que no siempre se cumplen, vínculos complejos y niñ@s que atraviesan estos días con un nivel de intensidad sensorial mayor que el de cualquier semana del año.',
      },
      {
        type: 'p',
        text: 'Quiero hablar de eso, sin recetas mágicas. Solo con una mirada clínica y humana, que ayuda a transitar este tiempo sin tanta exigencia y tal vez permitiéndonos el disfrute.',
      },
      { type: 'h', text: 'Un escenario sensorialmente intenso para l@s niñ@s' },
      {
        type: 'p',
        text: 'Si tenés hij@s, sabés de lo que hablo. En diciembre los horarios se alteran, las rutinas cambian, los estímulos se multiplican: luces, ruido, gente, espacios desconocidos, conversaciones, conversaciones. Es un torbellino sensorial para tod@s.',
      },
      {
        type: 'p',
        text: 'No es capricho cuando piden más brazos, cuando se esconden, cuando se enojan “de la nada”, cuando quieren irse o cuando parece que retrocedieron en autonomía. Es su sistema nervioso pidiendo referencias, un poco de previsibilidad, un lugar donde volver a sentirse segur@s.',
      },
      {
        type: 'p',
        text: 'En este contexto, ofrecerles —y ofrecernos— pausas, rincones tranquilos, un rato de aire, es importante. Hace falta acompañarlos desde la co-regulación: respirar vos, volver a su altura, conectar y escuchar.',
      },
      { type: 'h', text: 'Para las familias: expectativa social vs. necesidades reales' },
      {
        type: 'p',
        text: 'Vos también llegás a fin de año con lo tuyo: trabajo, cansancio, responsabilidades, cosas que quedaron pendientes, procesos personales que quizás siguen abiertos. Capaz este año fue difícil, o muy intenso, o estás sosteniendo más de lo que se ve.',
      },
      {
        type: 'p',
        text: 'Pero la voz cantante dice que “es época de unión”, “hay que festejar”. Y ahí aparece la tensión entre lo esperado y lo posible.',
      },
      {
        type: 'p',
        text: 'Tal vez estás atravesando un duelo, una distancia familiar, un conflicto, una etapa desafiante de la crianza, o simplemente estás cansada. Está bien. No hay nada que “arreglar”. Solo escucharte y no exigirte más de lo que puedas y desees sostener.',
      },
      {
        type: 'p',
        text: 'Y también está bien si llegás tarde porque tu bebé se durmió encima tuyo y no quisiste moverlo. Está bien si llegás con él en patas y tu tía se escandaliza. Está bien la forma que elegiste para criar, aunque otrxs no la compartan. Y está bien si necesitás irte a dormir antes, aunque la reunión esté a pleno. No tenés que demostrar nada: tu manera de cuidar es válida, suficiente y tuya.',
      },
      { type: 'h', text: 'Dar permiso: no todas las personas disfrutan esta época' },
      {
        type: 'p',
        text: 'Esto es algo que quiero enfatizar: no estás obligada a disfrutar las fiestas. No todas las familias la pasan bien, no tod@s l@s niñ@s lo viven como algo mágico, no todas las mujeres encuentran alegría, sostén y apoyo en la forma en que se organizan estas fechas.',
      },
      {
        type: 'p',
        text: 'Podés darte permiso para hacer pausa, para no cargar con expectativas ajenas, para correrte de los mandatos, para permitirte sentir lo que sea que esté presente.',
      },
      { type: 'h', text: 'Mirada clínica: pequeñas islas de seguridad' },
      {
        type: 'p',
        text: 'Desde el trabajo terapéutico y el acompañamiento a familias, este es un tiempo en el que trabajamos con l@s pacientes en buscar islas de seguridad, no resultados perfectos. Momentos donde vos y tu hij@ puedan volver a lo conocido:',
      },
      {
        type: 'list',
        items: [
          'un ratito de juego tranquilo,',
          'una mini siesta,',
          'salir a tomar aire,',
          'respirar junt@s,',
          'bajar las expectativas,',
          'soltar lo que no es esencial,',
          'buscar apoyo en alguien del entorno,',
          'anticipar lo que puedan,',
          'proteger los límites que cuidan.',
        ],
      },
      {
        type: 'p',
        text: 'No es evitar todo lo difícil, sino generar momentos de descanso emocional en el medio del movimiento.',
      },
      { type: 'h', text: 'No es hacer “las fiestas perfectas”, es sostener lo posible' },
      {
        type: 'p',
        text: 'Priorizar cuidar lo que se pueda cuidar, acompañar lo que aparezca y permitirte estar de una manera amable con vos misma.',
      },
      {
        type: 'p',
        text: 'No necesitamos agregar presión a un tiempo que ya viene cargado. Necesitamos habilitar espacios, bajar el ruido, acompañarnos con honestidad.',
      },
      {
        type: 'p',
        text: 'Si algo de esto te resonó, si sentís que te gustaría un espacio para trabajar cómo te atraviesa esta etapa y cómo acompañarte mejor a vos y a tu familia, sabés que en mi consultorio hay lugar para eso.',
      },
      { type: 'sign', text: 'Estoy acá para acompañarte.\nKarina' },
    ],
  },
];

export const faqs = [
  {
    q: '¿Cómo son las consultas? ¿Presenciales o virtuales?',
    a: 'Atiendo de forma presencial en Rosario, Colonia (Uruguay) y también ofrezco sesiones online por videollamada. La modalidad se elige según tu necesidad y comodidad.',
  },
  {
    q: '¿Cuánto dura una sesión?',
    a: 'Las sesiones individuales duran 50 minutos. Las consultas de lactancia y los espacios familiares pueden extenderse según lo que el encuentro requiera.',
  },
  {
    q: '¿Cada cuánto se realizan las sesiones?',
    a: 'En general, semanales al inicio del proceso. Luego, según el momento y los objetivos, podemos ajustar la frecuencia juntas.',
  },
  {
    q: '¿Atendés a niñ@s? ¿Cómo se trabaja con la familia?',
    a: 'Sí. En el trabajo con niñ@s, la familia y la escuela forman parte activa del proceso. Hay entrevistas con referentes adultos, devoluciones y acompañamiento integral.',
  },
  {
    q: '¿Qué pasa si no quiero amamantar o quiero destetar?',
    a: 'Mi acompañamiento no parte de un ideal. Acompaño la decisión que cada mujer toma, con información, sostén emocional y sin juicios.',
  },
  {
    q: '¿Cómo agendo una primera consulta?',
    a: 'Podés escribirme por WhatsApp. Coordinamos día, horario y modalidad, y conversamos lo necesario antes del primer encuentro.',
  },
];

export const navLinks = [
  { label: 'Talleres', href: '#eventos' },
  { label: 'Sobre mí', href: '#sobre-mi' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Mi enfoque', href: '#enfoque' },
  { label: 'Quizzes', href: '/quizzes', external: true },
  { label: 'Blog', href: '#blog' },
  { label: 'Contacto', href: '#contacto' },
];

// ================================================================
// CURSO VIRTUAL — Lactancia y Extracción
// ================================================================
// Editá los campos de cada módulo cuando tengas grabado el video.
// El campo `videoUrl` puede ser un link de:
//   - YouTube no listado:  https://www.youtube.com/embed/VIDEO_ID
//   - Vimeo privado:       https://player.vimeo.com/video/VIDEO_ID
// Si lo dejás vacío (''), aparece "Próximamente".
//
// El campo `bodyHtml` admite HTML simple (párrafos <p>, listas <ul><li>).
// ================================================================

export const courseInfo = {
  title: 'Curso virtual de extracción y lactancia',
  subtitle: 'Acompañamiento online para mamás que quieren entender, extraer y conservar su leche con calma',
  description:
    'Un curso pensado para vos: para que la vuelta al trabajo, una salida o una decisión propia no signifique dejar la lactancia. Información clara, sin juicios, basada en evidencia y en años de acompañamiento.',
  durationLabel: '8 módulos · ~2 hs de video · acceso por 6 meses',
  priceUYU: 500,
  priceUSD: 13,
  // contraseña (cliente edita antes de compartir): solo letras/numeros, 4+
  // ⚠️ NO es seguridad real, es un portón blando. La cambiás en mock.js cuando quieras.
  classroomPassword: 'lactancia2026',
  heroImage:
    'https://customer-assets.emergentagent.com/job_psych-portfolio-7/artifacts/b3ai1umv_DSC_0541.jpg',
  guarantees: [
    'Acceso por 6 meses a todos los videos y materiales',
    'Material descargable en PDF para acompañar cada módulo',
    'Atención por WhatsApp ante cualquier duda durante el curso',
    'Información actualizada y basada en evidencia',
  ],
  audience: [
    { icon: '·', text: 'Mamás que están por volver al trabajo' },
    { icon: '·', text: 'Familias que quieren conservar leche para emergencias' },
    { icon: '·', text: 'Mujeres que viajan o tienen rutinas largas fuera de casa' },
    { icon: '·', text: 'Quienes quieren amamantar más allá de los 6 meses' },
  ],
};

export const courseModules = [
  {
    id: 1,
    name: 'Bienvenida · Empecemos juntas',
    duration: '~10 min',
    summary:
      'Te cuento de qué se trata este curso, cómo aprovecharlo, y por qué lo que vamos a ver te va a dar tranquilidad.',
    videoUrl: '', // pegá acá el embed cuando tengas el video
    bodyHtml: `
      <p>Bienvenida. Este curso lo armé pensando en cada mamá que me escribe agotada o angustiada porque tiene que volver al trabajo o salir, y no sabe si va a poder seguir amamantando.</p>
      <p>Vas a poder ver los módulos en el orden que quieras y volver tantas veces como necesites. Te recomiendo empezar por este y por el de "cómo se produce la leche" para entender la base.</p>
    `,
  },
  {
    id: 2,
    name: 'Claves para lograr extracciones efectivas',
    duration: '~15 min',
    summary:
      'Técnica manual y con sacaleches, ritmo, frecuencia, postura y tips para que la extracción sea cómoda y productiva.',
    videoUrl: '',
    bodyHtml: `
      <p>En este módulo vamos a ver, paso a paso, cómo extraer leche sin lastimarte y obteniendo el máximo posible. Vamos con calma: la extracción es una habilidad que se aprende.</p>
      <ul>
        <li>Extracción manual: técnica de Marmet adaptada</li>
        <li>Sacaleches: cómo elegirlo y cómo usarlo</li>
        <li>Frecuencia y horarios sugeridos según tu situación</li>
      </ul>
    `,
  },
  {
    id: 3,
    name: 'Conservación de la leche',
    duration: '~12 min',
    summary:
      'Tiempos seguros a temperatura ambiente, heladera y freezer. Recipientes recomendados y errores frecuentes.',
    videoUrl: '',
    bodyHtml: `
      <p>La leche extraída es un tesoro. Acá vamos a ver cómo cuidarla para que conserve sus propiedades.</p>
    `,
  },
  {
    id: 4,
    name: 'Cómo se produce la leche y por qué baja la producción',
    duration: '~18 min',
    summary:
      'Fisiología de la lactancia explicada simple. Qué la favorece, qué la entorpece, y cómo recuperar producción.',
    videoUrl: '',
    bodyHtml: `
      <p>Entender cómo funciona tu cuerpo te da poder. Si sabés cómo se produce la leche, vas a poder cuidar tu producción y resolver bajones de forma tranquila.</p>
    `,
  },
  {
    id: 5,
    name: 'Tu propio banco de leche',
    duration: '~14 min',
    summary:
      'Cómo armar y organizar tu banco en casa. Rotación, etiquetado y planificación según cuánto te ausentás.',
    videoUrl: '',
    bodyHtml: `
      <p>Vamos a armar juntas tu propio banco de leche en casa, organizado y suficiente para tu rutina.</p>
    `,
  },
  {
    id: 6,
    name: 'Cuando no estás · cuánto y cómo toma tu bebé',
    duration: '~13 min',
    summary:
      'Cantidades realistas según edad, cómo coordinar tomas, y cómo acompañar al bebé en tu ausencia.',
    videoUrl: '',
    bodyHtml: `
      <p>Una de las preguntas más frecuentes: ¿cuánto toma cuando no estoy? Vamos a ver cantidades reales por edad y cómo organizar las tomas.</p>
    `,
  },
  {
    id: 7,
    name: 'Preparar a tu bebé para tomar tu leche',
    duration: '~14 min',
    summary:
      'Métodos de administración respetuosos: vasito, jeringa, dedo-jeringa, mamadera. Pros y contras de cada uno.',
    videoUrl: '',
    bodyHtml: `
      <p>No siempre es fácil que el bebé acepte tomar leche cuando vos no estás. Acá vemos opciones respetuosas y cómo elegir la mejor para tu familia.</p>
    `,
  },
  {
    id: 8,
    name: 'Atravesar las crisis · sostener tu lactancia',
    duration: '~15 min',
    summary:
      'Crisis de los 3 meses, huelgas de lactancia, picos de demanda. Qué son, qué no, y cómo no desistir.',
    videoUrl: '',
    bodyHtml: `
      <p>Las crisis de lactancia son momentos puntuales, no el final del camino. Te explico cuáles son las más comunes y cómo atravesarlas con calma.</p>
    `,
  },
];

export const courseFAQ = [
  {
    q: '¿Cómo accedo al curso una vez que pago?',
    a: 'Una vez confirmado tu pago (PayPal o transferencia), te envío por WhatsApp el link al aula virtual y la contraseña personal de acceso. Suele tomar entre unos minutos y unas pocas horas, según el horario.',
  },
  {
    q: '¿Por cuánto tiempo puedo ver los videos?',
    a: 'Tenés acceso por 6 meses desde el día en que recibís la contraseña. Podés volver a verlos las veces que quieras durante ese período.',
  },
  {
    q: '¿Cómo pago si no estoy en Uruguay?',
    a: 'Podés pagar con tarjeta a través de PayPal en USD 13. PayPal acepta tarjetas de débito y crédito de cualquier parte del mundo, no necesitás tener cuenta de PayPal.',
  },
  {
    q: '¿Y si soy de Uruguay?',
    a: 'Podés pagar por PayPal en USD o por transferencia bancaria local en pesos uruguayos ($500). Coordinamos los datos por WhatsApp.',
  },
  {
    q: '¿Puedo hacerte preguntas durante el curso?',
    a: 'Sí. Mientras dure tu acceso al aula, podés escribirme por WhatsApp por cualquier duda específica que te surja al avanzar con los módulos.',
  },
  {
    q: '¿Hay devolución si no me gusta?',
    a: 'Si en los primeros 7 días sentís que el curso no es para vos, te devuelvo el dinero. Sin preguntas. Mi compromiso es que te lleves valor real.',
  },
];

// ================================================================
// EVENTOS Y TALLERES
// ================================================================
// Para AGREGAR un nuevo evento: copiá uno de los bloques de abajo
// y pegalo dentro del array `events`. Editá los campos.
//
// Para QUITAR un evento: borralo del array (desde la "{" hasta la "},").
//
// Para PAUSAR un evento sin borrarlo: cambiá `active: true` por `active: false`.
//
// La sección entera se OCULTA si todos los eventos están en false.
// ================================================================

export const events = [
  {
    active: true,                              // true = se muestra · false = oculto
    id: 'entre-madres',
    title: 'Entre Madres',
    tagline: 'Un espacio para transitar la maternidad y sus procesos en compañía',
    status: 'Inscripciones abiertas',          // o "Próximamente", "Cupos limitados", etc.
    image: 'https://customer-assets.emergentagent.com/job_psych-portfolio-7/artifacts/nc5fhjj0_Entre%20madres%20corregido.png',
    imageMode: 'contain',                      // 'cover' (foto que llena) o 'contain' (flyer completo)
    imageBg: '#F1ECE3',                        // color de fondo cuando es 'contain'
    // Datos clave que aparecen como pills/etiquetas
    meta: [
      { icon: 'CalendarDays', label: 'Comienza el 13 de julio' },
      { icon: 'Repeat', label: 'Mensual · 2º lunes de cada mes' },
      { icon: 'MapPin', label: 'Colonia Valdense, Uruguay' },
      { icon: 'Users', label: 'Encuentros presenciales' },
      { icon: 'Sparkles', label: 'Aporte consciente' },
    ],
    // Resumen corto (se ve en la card)
    shortDescription:
      'Encuentros presenciales mensuales para mujeres que están atravesando la maternidad en distintos momentos y de distintas formas. Con hij@s, buscándol@s, en tratamientos o atravesando pérdidas. Un espacio donde lo que te pasa tiene lugar, sin tener que explicarlo todo perfecto.',
    // Bullets que aparecen en la card
    highlights: [
      'Comunidad de mujeres como sostén',
      'Trabajo con historia personal, patrones y vínculos',
      'Regulación emocional y corporal',
      'Prácticas vivenciales (no solo teoría)',
    ],
    // Modal expandido — secciones detalladas
    longContent: [
      {
        type: 'p',
        text: 'No es un curso, no es terapia individual, y no es un grupo para hacer catarsis y listo. Es un espacio presencial, para mujeres que están atravesando la maternidad en distintos momentos y de distintas formas: con hij@s, otras buscándol@s, otras en tratamientos, otras atravesando pérdidas.',
      },
      {
        type: 'p',
        text: 'No todas esas experiencias entran fácil en una palabra y muchas veces no hay dónde poner todo eso. Sabemos una cosa: que la maternidad mueve, a veces ordena algunas cosas y te acerca a encontrarte con formas más tuyas, y otras veces desarma todo. Este espacio busca darle lugar a esas experiencias diversas.',
      },
      { type: 'h', text: '¿Para quién es?' },
      {
        type: 'list',
        items: [
          'Sienten que están un poco desbordadas, aunque "todo esté bien"',
          'Se descubren reaccionando de formas que no les gustan',
          'Tienen información, pero igual no logran llevarla a la práctica',
          'Quieren criar distinto, pero no siempre saben cómo sostenerlo en lo cotidiano',
          'Necesitan un espacio propio (de verdad, no simbólico)',
        ],
      },
      {
        type: 'p',
        text: 'No hace falta "estar mal" para venir, alcanza con sentir ganas de estar en un espacio grupal, respetuoso y cuidado, donde no hay lugar para juzgar sino para acompañar, sostener y compartir procesos.',
      },
      { type: 'h', text: '¿Qué pasa en el espacio?' },
      {
        type: 'p',
        text: 'Nos encontramos en grupo, en un espacio cuidado, sin juicios. No es teórico, no es que yo hablo y ustedes escuchan. Trabajamos a partir de:',
      },
      {
        type: 'list',
        items: [
          'Situaciones reales que trae cada una',
          'Dinámicas grupales',
          'Herramientas concretas (regulación, vínculo, límites, aportes de otras disciplinas)',
          'Libros, canciones, poemas y otras formas de expresión que nos permitan acercarnos a las temáticas',
        ],
      },
      { type: 'h', text: 'Algunos ejes que vamos a trabajar' },
      {
        type: 'list',
        items: [
          'Formas de regularte y volver a un lugar más propio',
          'Vínculos: con tus hij@s, pareja, historia y entorno',
          'Autoexigencia, culpa y valor personal',
          'Patrones que se repiten (aunque quieras hacerlo distinto)',
          'Cuerpo, descanso y prácticas posibles de cuidado',
          'Reencuentro con vos más allá del rol materno',
          'Cambios en la pareja a partir de la maternidad y sexualidad en esta etapa',
          'Lo incómodo, lo que cuesta, lo que no suele decirse',
          'Red, comunidad y sostén entre mujeres',
        ],
      },
      { type: 'h', text: 'No es un espacio para…' },
      {
        type: 'list',
        items: [
          'Buscar una forma perfecta de ser o maternar',
          'Exigirnos más de lo que ya cargamos',
          'Minimizar o invalidar lo que sentimos',
          'Intentar entender lo que sentimos hoy sin integrar nuestra historia, patrones y contexto',
        ],
      },
      { type: 'h', text: 'Por qué acompaño este proceso' },
      {
        type: 'p',
        text: 'Porque yo también estuve y estoy ahí. Acompañada en lo formal, pero sola en lo importante, y con el tiempo empecé a verlo en todas partes: en el trabajo clínico, en la lactancia, con mujeres que llegan cansadas, desbordadas, sosteniendo todo y sin espacio para decirlo y ser comprendidas.',
      },
      {
        type: 'p',
        text: 'Acompaño desde mi formación —psicología, lo vincular, puericultura, doula— pero también desde lo que me tocó vivir. Soy madre de cuatro y me ha pasado de todo un poco: violencia obstétrica, momentos de mucho miedo, situaciones límite, cosas que te desarman y de las que te reconstruís con nuevas formas.',
      },
      {
        type: 'p',
        text: 'No acompaño desde un lugar de "enseñar", sino que estoy para sostener el espacio, cuidar lo que pasa ahí, y hacer que sea un lugar donde realmente se pueda estar sin juicio, sin competencia, sin tener que demostrar nada. Hay algo que me importa mucho: la maternidad no tendría que vivirse con este nivel de soledad.',
      },
      { type: 'h', text: 'Sobre el intercambio' },
      {
        type: 'p',
        text: 'Este espacio funciona con un aporte económico consciente. No porque "no tenga valor", sino justamente por lo contrario. Elegí que no haya un monto fijo para que el acceso no quede determinado solo por lo económico, y para que cada mujer pueda participar desde sus posibilidades reales.',
      },
      {
        type: 'p',
        text: 'Al mismo tiempo, el aporte es una forma de sostener el espacio, reconocer el trabajo, el tiempo y el cuidado que implica, y también de implicarse personalmente en el proceso. La idea es encontrar un punto que sea posible para vos y que, a la vez, cuide y valore el espacio.',
      },
      { type: 'sign', text: '¿Estás lista para sumarte?\nEscribime y te cuento.' },
    ],
    ctaLabel: 'Quiero sumarme',
    ctaWhatsappMessage: 'Hola Karina! Quiero sumarme a Entre Madres ✨',
  },
];
